import { createContext } from 'react';

import { EnhancedPlayback } from '@/scenarios/player/lib/enhancedPlayback';

export const PlaybackContext = createContext<EnhancedPlayback | null>(null);
